import TextBox from "devextreme-react/text-box";
import { Button as DevButton } from 'devextreme-react/button';
import React, { useCallback, useState } from "react";
import { thuPhiApi } from "../../../api/thuPhiApi";
import { showNotify } from "../../../helpers/toast";
import { Button } from "../../buttons";
import { DefaultPopup } from "../../modal";
type ThuPhiHuyChungTuBtnProps = {
    disabled: boolean,
    sf_mucphaithu_id: number,
    onChanged: () => void
}
const ThuPhiHuyChungTuBtn = (props: ThuPhiHuyChungTuBtnProps) => {
    const [isShowPopUp, setIsShowPopUp] = useState<boolean>(false);

    return (
        <>
            <DevButton
                text="Hủy chứng từ"
                type="danger"
                stylingMode="text"
                icon="trash"
                className="p-btn-devextreme"
                disabled={props.disabled}
                onClick={() => {
                    setIsShowPopUp(true);
                }}
            />
            {isShowPopUp && <HuyChungTuModal
                onClose={() => { setIsShowPopUp(false) }}
                onChanged={() => { setIsShowPopUp(false) ; props.onChanged()}}
                sf_mucphaithu_id={props.sf_mucphaithu_id}
            />}
        </>
    );
}

type HuyBienLaiModalProps = {
    onClose: () => void,
    onChanged:()=> void,
    sf_mucphaithu_id: number
}

export const HuyChungTuModal = (props: HuyBienLaiModalProps) => {
    const [ly_do_huy_phieu, set_ly_do_huy_phieu] = useState<string>("")
    const [isSaving, SetIsSaving] = useState<boolean>(false);

    const handleHuyChungTu = async () => {
        if (ly_do_huy_phieu == "") {
            showNotify({ message: "Vui lòng điền lý do hủy phiếu", type: "warning" });
            return false;
        }
        SetIsSaving(true)
        const res = await thuPhiApi.huy_chungtu({
            sf_mucphaithu_id: props.sf_mucphaithu_id,
            ly_do_huy: ly_do_huy_phieu
        });
        if (res.is_success) {
            showNotify({ message: "Đã hủy chứng từ", type: "success" });
            props.onChanged()
        } else {
            showNotify({ message: res.message || "Không hủy được chứng từ này", type: "warning" });

        }
        SetIsSaving(false)

    }
    const onClose = useCallback(() => {
        window.animationHidePopup("")
        setTimeout(() => {
            props.onClose();
        }, 500);
    }, [])
    return (
        <DefaultPopup title="Hủy chứng từ" onClose={onClose}>
            <div className="pop-up-form">
                <div className="col-md-12 padding-top-1rem">
                    <div className="form-group" style={{ minHeight: 100 }}>
                        <div className="form-label">Lý do hủy:</div>
                        <TextBox value={ly_do_huy_phieu}
                            stylingMode="outlined"
                            onValueChanged={(e) => {
                                set_ly_do_huy_phieu(e.value || "")
                            }}
                            valueChangeEvent="keyup"
                        />
                    </div>
                </div>

            </div>
            <div className="pop-up-actions">
                <Button type="normal" text="Đóng" onClick={() => { props.onClose() }} />{' '}
                <Button type="danger" isLoading={isSaving} isDisabled={ly_do_huy_phieu === ""} text="Hủy chứng từ" onClick={handleHuyChungTu} />
            </div>
        </DefaultPopup>
    )
}
export default ThuPhiHuyChungTuBtn